import React, { useState, useEffect, useRef } from 'react';
import '../../spinner.css';
import { useNavigate } from 'react-router-dom';
import { getUserDetails } from '../../services/UserService';
import { getNextModuleFromService, getPrevModuleFromService } from '../ModuleService';
import { getPedagogy } from '../../services/CourseService';
import Loader from '../../utility/Loader';
import SurveyPopup from './SurveyPopup';
import { getActiveSurveyQuestionWithId, addSurveyAnswer } from '../../services/Survey';
import { toast } from 'react-toastify';

export default function LearnerGame() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [module, setModule] = useState({});
    const [pedagogy, setPedagogy] = useState([]);
    const [shakeActive, setShakeActive] = useState(true);
    const [selectedPedagogy, setSelectedPedagogy] = useState({});
    const [fullView, setFullView] = useState(0);
    const [popupVisible, setPopupVisible] = useState(false);
    const [resolvePopup, setResolvePopup] = useState(null);
    const [allSurvey, setAllSurvey] = useState([]);

    useEffect(() => {
        const userDetails = getUserDetails();
        if (userDetails.token === undefined) {
            navigate('/login');
        } else {
            let moduleSelected = sessionStorage.getItem('currentModule') !== undefined ? JSON.parse(sessionStorage.getItem('currentModule')) : {};
            setModule(moduleSelected);
            const isAlreadySentHi = sessionStorage.getItem('qBotHi');
            if (isAlreadySentHi === undefined || isAlreadySentHi === null || isAlreadySentHi !== userDetails.user.first_name) {
                const dfMessenger = document.querySelector('df-messenger');
                dfMessenger.renderCustomText('Hello ' + userDetails.user.first_name + ', I am your friendly assistant. Let us make your learning journey seamless and enjoyable! Just type your question, and I will provide you with the information you need. Happy learning!', true);
                sessionStorage.setItem('qBotHi', userDetails.user.first_name);
            }

            getAllPedagogy(userDetails.token, moduleSelected.module_id);
        }
    }, []);

    const resetFullView = () => {
        fullView === 0 ? setFullView(1) : setFullView(0);
    };

    const getAllPedagogy = async (token, module_id) => {
        const userDetails = getUserDetails();
        let all = await getPedagogy(token, module_id);
        setPedagogy(all.data);
        if (all.data.length > 0) {
            setSelectedPedagogy(all.data[0]);

        }
    };

    const getActiveSurveyQuestionWithIdData = async () => {
        const userDetails = getUserDetails();

        let module_id = module.module_id;
        let resp = await getActiveSurveyQuestionWithId(userDetails.token, "module_id", module_id);
        if (resp.error === false && resp.data.length > 0) {
            setAllSurvey(resp.data);
            const inputValue = await showPopup();
            if (inputValue.length > 0) {
                let allObj = [];
                for (let i = 0; i < inputValue.length; i++) {
                    allObj.push({ survey_id: inputValue[i].id, user_id: userDetails.user.id, customer_id: userDetails.user.customer_id, user_answer: inputValue[i].answer, cohort_id: userDetails.user.cohort_id });
                }
                let resp1 = await addSurveyAnswer(userDetails.token, allObj);
                if (resp1.error === false) {
                    toast.success("Thank you for your feedback");
                } else {
                    toast.error("Some error occurred while recording your feedback");
                }
            }
        }
    };

    const showPopup = () => {
        return new Promise((resolve) => {
            setResolvePopup(() => resolve);
            setPopupVisible(true);
        });
    };

    const handleClose = (value) => {
        setPopupVisible(false);
        setAllSurvey([]);
        if (resolvePopup) {
            resolvePopup(value);
            setResolvePopup(null);
        }
    };

    const changeModule = async (changeType) => {
        const userDetails = getUserDetails();
        await getActiveSurveyQuestionWithIdData();
        let nextModule = {};
        if (changeType === "next") {
            nextModule = await getNextModuleFromService(module);
        } else {
            nextModule = await getPrevModuleFromService(module);
        }
        if (nextModule["module_type"] === undefined) {
            navigate('/learner/courses');
        }
        if (nextModule.module_type === module.module_type) {
            await getAllPedagogy(userDetails.token, nextModule.module_id);
            setModule(nextModule);
            return;
        }

        if (nextModule.module_type === "THEORY") {
            navigate('/learner/video');
        } else if (nextModule.module_type === "GAME") {
            navigate('/learner/game');
        } else if (nextModule.module_type === "ASSESSMENT") {
            navigate('/learner/assessment');
        } else {
            navigate('/learner/courses');
        }
    };

    return (
        <>
            <div>
                {loading ? (
                    <Loader />
                ) : (
                    <div className='py-10'>
                        <div className='lg:px-12 px-6 lg:pb-2 pb-1 md:border-b-2 md:border-[#D0D0D0]'>
                            <h3 className='text-2xl text-secondary inter-700 mb-3 lg:hidden'>{module.course_name}</h3>
                            <div className='beardcrumb-wrap mb-5'>
                                <ul className='flex flex-wrap items-center'>
                                    <li className='prev-page text-sm lg:text-lg inter-400 relative lg:mr-6 mr-4'>
                                        <a href='/learner/courses'>My Courses</a>
                                    </li>
                                    <li className='prev-page text-sm lg:text-lg inter-400 relative lg:mr-6 mr-4'>
                                        <a href='/learner/courses'>{module.course_name}</a>
                                    </li>
                                    <li className='current-page text-sm lg:text-lg inter-400 relative lg:mr-6 mr-4'>
                                        Lesson {module.module_seq_no}
                                    </li>
                                </ul>
                            </div>
                            <div className='course-heading-wrap lg:mb-6 mb-5'>
                                {/* <h3 className='text-tertiary text-xl lg:text-2xl inter-500 mb-1'>Lesson {module.module_seq_no}</h3> */}
                                <h2 className='text-[#1D548D] text-2xl inter-500'>{module.module_desc}</h2>
                            </div>

                        </div>
                        <div>
                            {pedagogy.length > 0 && selectedPedagogy.pedagogy_type === 'GAME' ? (
                                <div className='lg:pt-10 pt-8 pb-8 border-b-2 border-[#D0D0D0]'>
                                    <div className='video-box w-full h-[500px] lg:h-[800px] 2xl:h-[920px]'>
                                        <iframe
                                            title="Game"
                                            src={selectedPedagogy.url}
                                            width="100%"
                                            height="100%"
                                            frameBorder="0"
                                        >
                                        </iframe>
                                    </div>
                                    <div className='lg:px-12 px-6'>
                                        <h4 className='text-xl text-black inter-700 mt-4'>{selectedPedagogy.title}</h4>
                                        {selectedPedagogy.text !== undefined && selectedPedagogy.text !== '' && selectedPedagogy.text !== null ? (
                                            <>
                                                {fullView === undefined || fullView === 0 ? (
                                                    <p className='text-base inter-400 text-black mt-4'>
                                                        {selectedPedagogy.text.substring(0, 300)} &nbsp;&nbsp;&nbsp;
                                                        {selectedPedagogy.text.length <= 300 ? (
                                                            null
                                                        ) : (
                                                            <a onClick={() => resetFullView()} className='cursor-pointer text-secondary'>Show More</a>
                                                        )}
                                                    </p>
                                                ) : (
                                                    <p className='text-base inter-400 text-black mt-4'>
                                                        {selectedPedagogy.text} &nbsp;&nbsp;&nbsp;
                                                        <a onClick={() => resetFullView()} className='cursor-pointer text-secondary'>Show Less</a>
                                                    </p>
                                                )}
                                            </>
                                        ) : (
                                            null
                                        )}
                                    </div>
                                </div>
                            ) : (
                                null
                            )}
                        </div>



                        <div className='lg:py-10 md:py-8 py-0 lg:px-12 px-6 course-navigate-btns flex flex-wrap justify-between'>
                            <a onClick={() => changeModule("prev")} className='w-full md:w-max mb-4 md:mb-0 cursor-pointer bg-secondary hover:bg-black flex items-center justify-center px-6 h-10 2xl:h-16 text-white inter-700 text-base 2xl:text-2xl rounded-3xl lg:rounded-full transition duration-300 button-shadow'>Previous Lesson</a>
                            <a onClick={() => changeModule("next")} className='w-full md:w-max cursor-pointer bg-secondary hover:bg-black flex items-center justify-center px-6 h-10 2xl:h-16 text-white inter-700 text-base 2xl:text-2xl rounded-3xl lg:rounded-full transition duration-300 button-shadow'>Next Lesson</a>
                        </div>
                    </div>
                )}
            </div>
            {/* In chat-bbl-text we need to add class "active-chat" on click chat bubble */}
            <div className={shakeActive ? 'chat-bbl-text fixed bottom-7 right-24 z-50' : 'chat-bbl-text fixed bottom-7 right-24 z-50'}>
                <p className='text-xs inter-500 text-white bg-[#620b57] py-3 px-3 rounded-md relative'>
                    Ask Me Anything
                </p>
            </div>
            <df-messenger
                project-id="qlitex"
                agent-id="5e294f2b-c5c9-49a4-9170-20db654a8460"
                language-code="en"
                max-query-length="-1"
                allow-feedback="all">
                <df-messenger-chat-bubble
                    chat-title="Q-Bot" chat-icon="https://storage.googleapis.com/q-lite/Icon-01.svg" chat-title-icon="https://storage.googleapis.com/mediajenie/QLITE_Logo-01.svg">
                </df-messenger-chat-bubble>
            </df-messenger>
            {popupVisible && <SurveyPopup onClose={handleClose} questions={allSurvey} />}
        </>
    );
}